export const substrMultiByte = (text: string, len: number, truncation = ''): string => {
  const textArray = Array.from(text)
  let count = 0
  let str = ''
  for (let i = 0;i < textArray.length;i += 1) {
    const n = escape(textArray[i])
    if (n.length < 4) {
      count += 1
    } else {
      count += 2
    }
    if (count > len) return str + truncation
    str += text.charAt(i)
  }
  return text
}

export const replaceAndStrip = (value: string): string => {
  if (value === undefined || value === null) return ''

  // eslint-disable-next-line no-control-regex
  return value.replace(/\u000B|\u000C|\u001C|\u001D|\u001E|\u001F|\u00A0/g, ' ').trim()
}

export const kanaToHira = (word: string): string => word.replace(/[\u30a1-\u30f6]/g, ((match) => {
  const charCode = match.charCodeAt(0) - 0x60
  return String.fromCharCode(charCode)
}))

export const hiraToKana = (word: string): string => word.replace(/[\u3041-\u3096]/g, ((match) => {
  const charCode = match.charCodeAt(0) + 0x60
  return String.fromCharCode(charCode)
}))

export const zenToHan = (str: string): string => str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, (s: string) => String.fromCharCode(s.charCodeAt(0) - 0xFEE0))

export const nl2br = (str: string | null): string => {
  if (!str) return ""
  return str.replace(/\r\n/g, "<br />").replace(/(\n|\r)/g, "<br />")
}

export const pickNumber = (word: string): string => word.replace(/[^0-9]/g, '')

// ファイルパスから末尾のファイル名(パスを含まない全文)を取得する。
// パス区切りは / と \ の両方に対応。
export const getFileName = (path: string): string => {
  if (!path) return ''
  return path.split(/[\\/]/).pop() ?? ''
}

// ファイルパス / ファイル名から拡張子のみを取得する(先頭のドットは含まない)。
// パス区切りは / と \ の両方に対応。拡張子が無い場合や隠しファイル(.gitignore 等)は空文字を返す。
export const getFileExtension = (path: string): string => {
  const fileName = getFileName(path)
  const dotIndex = fileName.lastIndexOf('.')
  if (dotIndex <= 0) return ''
  return fileName.slice(dotIndex + 1)
}

export const quoteSplit = (word: string): string[] => {
  let c = ""
  let s = ""
  const data = []
  let groupFlg = false

  for (let i = 0;i < word.length;i += 1) {
    c = word.charAt(i)
    if (i === word.length - 1) {
      if (c === '"' || c === " " || c === '　') {
        data.push(s.toString())
      } else {
        data.push((s + c).toString())
      }
    } else if ((c === " " || c === '　') && !groupFlg) {
      data.push(s.toString())
      s = ""
    } else if ((c === " " || c === '　') && groupFlg) {
      s += c
    } else if (c === '"') {
      groupFlg = !groupFlg
    } else {
      s += c
    }
  }
  return data
}
